import { fontVariants } from "../../../../styles/stitches.config"
import { CSSProp, styled, theme } from "../../../../styles/stitches.config"

export const SContentWrapper = styled("div", {
  lineHeight: theme.sizes.s5_5,
  fontWeight: theme.fontWeights.regular,
  fontFamily: "Poppins, sans-serif",
})

const baseInputStyles: CSSProp = {
  height: 43,
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: theme.space.s6,
  fontSize: theme.fontSizes.small,
  width: "100%",
  color: theme.colors.texts,
  transition: "border-color .25s ease-out",
  background: "transparent",
  border: "2px solid #7CA7AD",
  appearance: "none",

  "&:disabled": {
    backgroundColor: theme.colors.textsDisabeled,
    cursor: "not-allowed",
    hover: {
      borderColor: theme.colors.textsAlt,
    },
  },

  "&::placeholder": {
    color: theme.colors.textsDisabeled,
  },
}

export const SInput = styled("input", {
  ...baseInputStyles,

  hover: {
    borderColor: theme.colors.primary,
  },

  "&:focus": {
    borderColor: theme.colors.primary,
  },

  appearance: "textfield",

  variants: {
    state: {
      success: {
        borderColor: theme.colors.successes,
      },
      error: {
        borderColor: theme.colors.errors,
      },
      default: {
        borderColor: theme.colors.textsAlt,
      },
    },

    hasLeftContent: {
      true: {
        paddingLeft: theme.space.s30,
      },
    },
  },

  defaultVariants: {
    state: "default",
  },
})

export const STextArea = styled("textarea", {
  ...baseInputStyles,

  lineHeight: "45px",
  height: theme.sizes.s21,
  minWidth: theme.sizes.s60,

  hover: {
    borderColor: theme.colors.primary,
  },

  "&:focus": {
    borderColor: theme.colors.primary,
  },
})

export const SInputWrapper = styled("div", {
  position: "relative",
  width: "100%",
})

export const SLeftContentWrapper = styled("div", {
  position: "absolute",
  left: 15,
  top: 0,
  bottom: 0,
  width: theme.space.s24,
})

export const SRightContentWrapper = styled("div", {
  position: "absolute",
  top: 0,
  bottom: 0,
  right: 16,
  width: theme.space.s6,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  pointerEvents: "none",
})

export const SLabel = styled("label", {
  color: theme.colors.primary,
  fontSize: theme.fontSizes.small,
  lineHeight: theme.sizes.s6_5,
  fontWeight: theme.fontWeights.regular,
})

export const SSelect = styled("select", {
  ...baseInputStyles,

  hover: {
    borderColor: theme.colors.primary,
  },

  "&:invalid": {
    color: theme.colors.textsDisabeled,
  },

  variants: {
    hasRightContent: {
      true: {
        paddingRight: theme.space.s10,
      },
    },

    state: {
      success: {
        borderColor: theme.colors.successes,
      },
      error: {
        borderColor: theme.colors.errors,
      },
      default: {
        borderColor: theme.colors.textsAlt,
      },
    },
  },

  defaultVariants: {
    state: "default",
  },
})

export const SResponsiveRow = styled("div", {
  display: "flex",
  gap: theme.space.s6_5,
  flexWrap: "wrap",
  justifyContent: "center",

  "@sm": {
    flexWrap: "nowrap",
  },
})

export const SSectionWrapper = styled("section", {})

export const SFileInputWrapper = styled("label", {
  display: "flex",
  flexDirection: "column",

  gap: 8,
  cursor: "pointer",

  ellipsis: {},
  "@sm": {
    flexDirection: "row",
  },
})

export const SFileInput = styled("div", {
  position: "relative",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: theme.space.s6,

  ellipsis: {},

  height: 50,
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 24,
  paddingRight: 15,
  fontSize: 14,

  width: "100%",
  transition: "border-color .25s ease-out",
  background: "transparent",

  variants: {
    state: {
      success: {
        ...fontVariants.headerH3,
        border: `2px solid ${theme.colors.successes.value}`,
      },
      error: {
        color: theme.colors.textsAlt,
        border: `2px solid ${theme.colors.errors.value}`,
      },
      default: {
        color: theme.colors.textsAlt,
        border: `2px dashed ${theme.colors.textsAlt.value}`,
      },
    },
  },

  defaultVariants: {
    state: "default",
  },
})
